import { GigType } from "model/Gig";

import type {
  FormData,
  RecruitFormData,
  SelectedWorker,
} from "../modal/gigFormModal.types";

export type CreateGigPayload = FormData &
  Partial<RecruitFormData> & {
    parentGigId?: number;
    workerId?: number;
    workGroupId?: number;
  };

const assertUnreachableGigType = (gigType: never): never => {
  throw new Error(`Unhandled create gig type: ${String(gigType)}`);
};

/**
 * Returns the worker iteration list used when creating gigs for a given gig type.
 */
export const getCreateGigItems = (
  type: FormData["type"],
  selectedWorkers: SelectedWorker[],
): Array<SelectedWorker | null> => {
  switch (type) {
    case GigType.PUBLIC:
      return [null];
    case GigType.WORKPOOL:
      return [null];
    case GigType.SOLO:
      return selectedWorkers;
  }

  return assertUnreachableGigType(type);
};

/**
 * Builds create-gig payload data from form state and optional worker context.
 */
export const buildCreateGigPayload = (
  formData: FormData,
  recruitFormData: RecruitFormData,
  parentGigId?: number,
  worker?: SelectedWorker | null,
): CreateGigPayload => {
  switch (formData.type) {
    case GigType.PUBLIC:
      return { ...recruitFormData, ...formData };
    case GigType.WORKPOOL:
      return {
        ...recruitFormData,
        ...formData,
        minRate: 0,
        maxRate: 0,
      };
    case GigType.SOLO:
      return {
        ...formData,
        parentGigId,
        ...(worker && {
          workerId: worker.workerId ?? worker.id,
          workGroupId: worker.selectedTeamId ?? undefined,
        }),
      };
  }

  return assertUnreachableGigType(formData.type);
};
